import React, { Component } from "react"
import styled from "styled-components"
import ReactPopup from "reactjs-popup"
import colors from "../../styles/colors"
import CloseIcon from "../../resources/img/ui/popup/popup-close.svg"

const PopUpContent = styled.div`
height: 100%;
`;

const Close = styled.img`
    height: 16px;
    width: 16px;
    position: absolute;
    right: 20px;
    top: 26px;
    cursor: pointer;
`;

const contentStyle = {
  width: '676px',
  margin: 'auto',
  background: `${colors.white}`,
  border: `2px solid ${colors.green}`,
  paddingTop: '46px',
  paddingBottom: '47px',
  paddingLeft: '20px',
  paddingRight: '20px',
  boxSizing: 'border-box',
  height: '495px',
  overflow: 'auto',
  position: 'relative',
};

const contentStyleMobile = {
  width: '100%',
  maxWidth: '375px',
  margin: 'auto',
  marginTop: '60px',
  background: `${colors.white}`,
  border: `2px solid ${colors.green}`,
  paddingTop: '46px',
  paddingBottom: '20px',
  paddingLeft: '20px',
  paddingRight: '20px',
  height: 'auto',
  overflow: 'auto',
  position: 'relative',
};

const overlayStyle = {
  overflowY: 'auto',
  background: 'rgba(248, 245, 243, 0.9)'
};

const overlayStyleMobile = {
  overflowY: 'auto',
  background: 'rgba(248, 245, 243, 0.9)',
};

class Popup extends Component {
  state = {
    width: 0,
    height: 0
  };

  changeActive = (active) => {
    this.setState({
      active: active
    })
  };

  componentDidMount = () => {
    if (typeof window !== 'undefined') {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  };

  componentWillUnmount = () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  };

  updateWindowDimensions = () => {
    if (typeof window !== 'undefined') {
      this.setState({width: window.innerWidth, height: window.innerHeight});
    }
  };

  getContentStyle = () => {
    if (this.state.width >= 700) {
      return contentStyle;
    } else if (this.state.width < 700) {
      return contentStyleMobile;
    }
  };

  render() {
    const {open, handlePopup} = this.props;

    return (
      <ReactPopup
        contentStyle={this.getContentStyle()}
        overlayStyle={this.state.width >= 699 ? overlayStyle : overlayStyleMobile}
        open={open}
        closeOnDocumentClick
        onClose={() => handlePopup(false)}>
        <>
          <PopUpContent>
            {this.props.children}
          </PopUpContent>
          <Close src={CloseIcon} onClick={() => handlePopup(false)} alt={"Close"}/>
        </>
      </ReactPopup>
    );
  }
}

export default Popup;
